import { ActionType } from '@/models/enum-types/action-type.enum'
import IDataInfo from '@/models/modelView/IDataInfo'
import DeviceViewData from '@/models/modelView/IDeviceView'
import DeviceStore from '@/models/modelStore/IDeviceStore'
import IPosition from '@/models/dto/position.dto'
import IDeviceStore from '@/models/modelStore/IDeviceStore'
import IReportDetails from '@/models/modelView/report-details'
import { FuelTypeUnitEnum } from '@/models/enum-types/fuel-type-unit.enum'
import { FuelTypeMoneyEnum } from '@/models/enum-types/fuel-type-money.enum'

export abstract class ModemStrategy {
    abstract customAttributes: any[]
    abstract sendCommand(deviceId: number, type: ActionType, data?: string): any
    abstract mapDevice(device: DeviceStore): DeviceViewData
    abstract getReportDetails(data: IPosition[], device: IDeviceStore): IReportDetails | null
    abstract getExtraAttributes(attributes: any): IDataInfo[]

    mapAttributes(attributes: any = {}, device: IDeviceStore): IDataInfo[] {
        const list: IDataInfo[] = []
        if (device) this.addHorometer(device)
        console.log(this.customAttributes)
        this.customAttributes.forEach((item) => {
            /* eslint-disable */
            const factor = item.factor || 1
            const precision = item.precision ?? 2

            const virtualOdometer = device?.attributes?.services?.find((item) => item.name == 'virtual_odometer')?.value
            if (virtualOdometer && item.name == 'odometer') {
                item.name = 'totalDistance'
            }
            try {
                if (attributes[item.name] || attributes[item.name] == 0) {
                    list.push({
                        title: item.viewName,
                        value: (attributes[item.name] * factor).toFixed(precision) + item.suffix,
                    })
                }
            } catch (_) {}
        })
        return list.concat(this.getExtraAttributes(attributes) || [])
    }

    genericReportDetails(data: IPosition[], device: IDeviceStore): IReportDetails {
        let filteredData: any[]
        let diff
        const virtualOdometer = device?.attributes?.services?.find((item) => item.name == 'virtual_odometer')?.value
        if (virtualOdometer) {
            filteredData = data.filter((item) => item.attributes?.totalDistance)
            diff =
                filteredData[filteredData.length - 1].attributes.totalDistance -
                filteredData[0].attributes.totalDistance
        } else {
            filteredData = data.filter((item) => item.attributes?.odometer)
            diff = filteredData[filteredData.length - 1].attributes.odometer - filteredData[0].attributes.odometer
        }
        console.log(filteredData)
        if (filteredData.length < 2) throw new Error('Odometer Not Found.')
        else {
            const params = device.attributes?.params
            const diffKms = diff / 1000
            const performance = (1 / (params?.fuelEfficiency || params?.fuel_efficiency || 1)) * diffKms
            const fuelType = params?.fuelType || params?.fuel_type!
            return {
                columns: [
                    {
                        name: 'Kms',
                        value: diffKms.toFixed(2),
                    },
                    {
                        name: Object(FuelTypeUnitEnum)[fuelType],
                        value: performance.toFixed(2),
                    },
                    {
                        name: Object(FuelTypeMoneyEnum)[fuelType],
                        value: (performance * (params?.fuelCost || params?.fuel_cost || 0)).toFixed(2),
                    },
                ],
                plate: device.name,
                icon: device.icon,
                visible: true,
            }
        }
    }

    addHorometer(device: IDeviceStore) {
        const services = device.attributes?.services || []
        console.log(services)
        const horometerService = services.find((service) => service.name == 'horometer')
        if (horometerService?.value) {
            this.customAttributes.unshift({
                name: 'hours',
                viewName: 'Horo:',
                suffix: ' H',
                factor: 1 / 3600000,
                precision: 2,
            })
        }
    }
}
